import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const modulePdfConfiguration = {
  namespaced: true,

  state: {
    name: 'pdf-configuration',
    pdfConfigurations: []
  },

  mutations,
  getters,
  actions
}

export default modulePdfConfiguration;